import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Select from 'react-select';
import API from '../../utils/API';

class GlobalSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            searching: false,
            searchOrg: false,
            results: [],
            searchResultOptions: {
                organization: {
                    events: {
                        label: 'Events',
                        options: [],
                    },
                    programs: {
                        label: 'Programs',
                        options: [],
                    },
                    contacts: {
                        label: 'Contacts',
                        options: [],
                    },
                    pages: {
                        label: 'Pages',
                        options: [],
                    },
                    forms: {
                        label: 'Forms',
                        options: [],
                    },
                    media: {
                        label: 'Media',
                        options: [],
                    }
                },
                event: {
                    attendees: {
                        label: 'Attendees',
                        options: [],
                    },
                    sessions: {
                        label: 'Sessions',
                        options: [],
                    },
                    groups: {
                        label: 'Groups',
                        options: [],
                    },
                    inventory: {
                        label: 'Inventory',
                        options: [],
                    },
                    emails: {
                        label: 'Email Campaigns',
                        options: [],
                    },
                    texting: {
                        label: 'Text Campaigns',
                        options: [],
                    },
                    forms: {
                        label: 'Forms',
                        options: [],
                    },
                    pages: {
                        label: 'Pages',
                        options: [],
                    },
                    media: {
                        label: 'Media',
                        options: [],
                    }
                },
            }
        };
    }

    searchPlatform = async () => {
        const { search, searchOrg } = this.state;
        const { organization, event } = this.props;
        if (search.length == 1) {
            this.setState({ searching: true });
            if (event && !searchOrg) {
                const results = await API().post(`/platformActions/search/${organization._id}/${event._id}`, { search }).catch(err => console.log(err));
                const searchResultOptions = this.state.searchResultOptions;
                const eventResultOptions = [];
                results.data && results.data.event && Object.keys(results.data.event).forEach(key => {
                    eventResultOptions.push({
                        label: searchResultOptions.event[key].label, options: results.data.event[key].map(item => {
                            return {
                                value: key == "media" ? item.url : item._id,
                                label: key == 'attendees' ? `${item.firstName} ${item.lastName} [${item.email}]` : key == 'pages' ? item.title : item.name,
                                type: key,
                                isEvent: true
                            }
                        })
                    });
                });
                this.setState({ results: eventResultOptions, searching: false });
            } else {
                const results = await API().post(`/platformActions/search/${organization._id}/false`, { search });
                const searchResultOptions = this.state.searchResultOptions;
                const orgResultOptions = [];
                results.data && results.data.organization && Object.keys(results.data.organization).forEach(key => {
                    orgResultOptions.push({
                        label: searchResultOptions.organization[key].label, options: results.data.organization[key].map(item => {
                            return {
                                value: key == "media" ? item.url : item._id,
                                label: key == 'contacts' ? `${item.firstName} ${item.lastName} (${item.emailAddress})` : key == 'pages' ? item.title : item.name,
                                type: key,
                                isEvent: false
                            }
                        })
                    });
                }
                );
                this.setState({ results: orgResultOptions, searching: false });
            }
        } else if (search.length == 0) {
            this.setState({ results: [], searching: false });
        }
    }

    onResultSelected = (e) => {
        const { organization, event } = this.props;
        const { type, isEvent } = e;
        if (isEvent) {
            if (type == 'attendees') {
                this.props.history.push(`/${organization._id}/events/${event._id}/attendees/${e.value}`);
            } else if (type == 'sessions') {
                this.props.history.push(`/${organization._id}/events/${event._id}/session/${e.value}`);
            } else if (type == 'groups') {
                this.props.history.push(`/${organization._id}/events/${event._id}/groups/${e.value}`);
            } else if (type == 'inventory') {
                this.props.history.push(`/${organization._id}/events/${event._id}/inventory/${e.value}`);
            } else if (type == 'emails') {
                this.props.history.push(`/${organization._id}/events/${event._id}/emails/${e.value}`);
            } else if (type == 'texting') {
                this.props.history.push(`/${organization._id}/events/${event._id}/texting/${e.value}`);
            } else if (type == 'forms') {
                this.props.history.push(`/${organization._id}/events/${event._id}/forms/${e.value}`);
            } else if (type == 'pages') {
                this.props.history.push(`/${organization._id}/events/${event._id}/pages/${e.value}`);
            } else if (type == 'media') {
                window.open(e.value, '_blank');
            }

        } else {
            if (type == 'contacts') {
                this.props.history.push(`/${organization._id}/contacts/${e.value}`);
            } else if (type == 'events') {
                this.props.history.push(`/${organization._id}/events/${e.value}`);
            } else if (type == 'programs') {
                this.props.history.push(`/${organization._id}/programs/${e.value}`);
            } else if (type == 'forms') {
                this.props.history.push(`/${organization._id}/forms/${e.value}`);
            } else if (type == 'pages') {
                this.props.history.push(`/${organization._id}/pages/${e.value}`);
            } else if (type == 'media') {
                window.open(e.value, '_blank');
            }
        }
    }

    render() {
        const { search, searching, results } = this.state;
        return (
            <Select
                name="search"
                value={search}
                classNamePrefix="search"
                options={search == '' ? [] : results}
                className="w-100"
                onInputChange={(text) => {
                    this.setState({ search: text }, this.searchPlatform);
                }}
                onChange={this.onResultSelected}
                placeholder={this.props.event ? "Search event..." : "Search organization..."}
                noOptionsMessage={() =>
                    !searching ? 'Search for anything by name' : 'Searching...'}
                formatGroupLabel={data => (
                    <h5 className="mb-10">
                        {data.label}
                    </h5>
                )}

                styles={{
                    valueContainer: (e) => ({
                        ...e,
                        height: 30,
                        backgroundColor: 'transparent'
                    }),
                    singleValue: (e) => ({
                        ...e,
                        height: 30
                    }),
                    indicatorSeparator: (e) => ({
                        ...e,
                        display: 'none'
                    }),
                    dropdownIndicator: (e) => ({
                        ...e,
                        display: 'none'
                    }),
                    input: (e) => ({
                        ...e,
                        height: 30,
                        lineHeight: 1.2,
                        backgroundColor: 'transparent'
                    }),
                    option: (e) => ({
                        ...e,
                        height: 30,
                        lineHeight: 1.2
                    })
                }}
            />
        );
    }
}

export default withRouter(GlobalSearch);